module.exports = __webpack_public_path__ + "img/kwai_icon-v2.e68969ce.svg";